import { Directive, ElementRef, HostListener, Input } from '@angular/core';
import { FormGroupDirective } from '@angular/forms';
import { fromEvent } from 'rxjs';
import { debounceTime, take } from 'rxjs/operators';

/**
 * Scrolls the view to the first invalid element of a form.
 */
@Directive({
  selector: '[mfpInvalidFormScroll]'
})
export class InvalidFormScrollDirective {
  @Input() invalidFormScrollOffset = 50;
  @Input() invalidFormScrollContainerId = 'layoutScrollContainer';

  private get scrollContainerEl(): HTMLElement {
    const layoutScrollContainer = document.body.querySelector(`#${this.invalidFormScrollContainerId}`);
    return layoutScrollContainer as HTMLElement;
  }

  constructor(private el: ElementRef, private formGroupDir: FormGroupDirective) {}

  @HostListener('ngSubmit')
  onSubmit() {
    if (this.formGroupDir.control.invalid) {
      this.scrollToFirstInvalidControl();
    }
  }

  private scrollToFirstInvalidControl() {
    const firstInvalidControl: HTMLElement = this.el.nativeElement.querySelector('.ng-invalid');

    const topOffset = this.getTopOffset(firstInvalidControl);
    const containerEl = this.scrollContainerEl;
    containerEl.scroll({
      top: topOffset,
      left: 0,
      behavior: 'smooth'
    });

    fromEvent(this.scrollContainerEl, 'scroll')
      .pipe(debounceTime(100), take(1))
      .subscribe({
        next: () => firstInvalidControl.focus()
      });
  }

  private getTopOffset(controlEl: HTMLElement): number {
    const controlElTop = controlEl.getBoundingClientRect().top;

    if (this.scrollContainerEl) {
      const containerTop = this.scrollContainerEl.getBoundingClientRect().top;
      const absoluteControlElTop = controlElTop + this.scrollContainerEl.scrollTop;
      return absoluteControlElTop - containerTop - this.invalidFormScrollOffset;
    } else {
      const absoluteControlElTop = controlElTop + window.scrollY;
      return absoluteControlElTop - this.invalidFormScrollOffset;
    }
  }
}
